var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useCallback, useEffect, useRef } from 'react';
import { handleServiceError } from "../components/ErrorHandler";
import CustomerService from "../../Customer/services/CustomerService";
import { useLocation } from "react-router-dom";
var PROVIDERS_CACHE_TTL = 1000 * 60 * 2;
var REFERENCE_CACHE_TTL = 1000 * 60 * 2;
var FILTER_DEBOUNCE_MS = 300;
var PREFETCH_DELAY_MS = 1500;
var PROVIDERS_CACHE_STORAGE_KEY = "cache:providers";
var PROVIDERS_CACHE_MAX_ENTRIES = 30;
function getCachedReference(key, fetcher) {
    return __awaiter(this, void 0, void 0, function () {
        var cached, _a, data, timestamp, result;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    cached = sessionStorage.getItem(key);
                    if (cached) {
                        _a = JSON.parse(cached), data = _a.data, timestamp = _a.timestamp;
                        if (Date.now() - timestamp < REFERENCE_CACHE_TTL) {
                            return [2 /*return*/, data];
                        }
                    }
                    return [4 /*yield*/, fetcher()];
                case 1:
                    result = _b.sent();
                    sessionStorage.setItem(key, JSON.stringify({ data: result, timestamp: Date.now() }));
                    return [2 /*return*/, result];
            }
        });
    });
}
function loadProvidersCache() {
    var map = new Map();
    var raw = sessionStorage.getItem(PROVIDERS_CACHE_STORAGE_KEY);
    if (!raw)
        return map;
    var parsed = JSON.parse(raw);
    var now = Date.now();
    for (var _i = 0, parsed_1 = parsed; _i < parsed_1.length; _i++) {
        var _a = parsed_1[_i], key = _a[0], entry = _a[1];
        if (now - entry.timestamp < PROVIDERS_CACHE_TTL) {
            map.set(key, entry);
        }
    }
    return map;
}
function persistProvidersCache(cache) {
    try {
        var entries = Array.from(cache.entries())
            .sort(function (a, b) { return b[1].timestamp - a[1].timestamp; })
            .slice(0, PROVIDERS_CACHE_MAX_ENTRIES);
        sessionStorage.setItem(PROVIDERS_CACHE_STORAGE_KEY, JSON.stringify(entries));
    }
    catch (_a) {
    }
}
/**
 * Invalida o cache da listagem de provedores para forçar um refetch na próxima
 * montagem. Chamar após mutações que alterem dados exibidos na tabela (ex.: trocar
 * a carência de um provedor, que muda a coluna "Carência"/fim do período).
 */
export function invalidateProvidersCache() {
    try {
        sessionStorage.removeItem(PROVIDERS_CACHE_STORAGE_KEY);
    }
    catch (_a) {
    }
}
function parseDueStatus(raw) {
    if (!raw)
        return [];
    try {
        var value = JSON.parse(raw);
        return Array.isArray(value) ? value : [];
    }
    catch (_a) {
        return [];
    }
}
function useDebouncedValue(value, delay) {
    var _a = useState(value), debounced = _a[0], setDebounced = _a[1];
    useEffect(function () {
        var t = setTimeout(function () { return setDebounced(value); }, delay);
        return function () { return clearTimeout(t); };
    }, [value, delay]);
    return debounced;
}
var useCustomerData = function (_customerInfo) {
    var readInitialFilters = function () {
        var checkKeep = function () {
            var _a, _b;
            try {
                var state = ((_b = (_a = window.history.state) === null || _a === void 0 ? void 0 : _a.usr) !== null && _b !== void 0 ? _b : null);
                return !!(state === null || state === void 0 ? void 0 : state.keep);
            }
            catch (_c) {
                return false;
            }
        };
        var selectedState = sessionStorage.getItem('selectedState');
        var selectedPlan = sessionStorage.getItem('selectedPlan');
        var selectedStatus = sessionStorage.getItem('selectedStatus');
        var selectedErp = sessionStorage.getItem('selectedErp');
        var selectedDueStatus = sessionStorage.getItem('selectedDueStatus');
        var savedSearchTerm = sessionStorage.getItem('searchingTerm');
        var hasAny = !!(selectedState || selectedPlan || selectedStatus || selectedErp || selectedDueStatus || savedSearchTerm);
        var shouldRestore = checkKeep() || hasAny;
        if (!shouldRestore) {
            sessionStorage.removeItem('searchingTerm');
            sessionStorage.removeItem('paginateUrl');
            sessionStorage.removeItem('selectedState');
            sessionStorage.removeItem('selectedPlan');
            sessionStorage.removeItem('selectedStatus');
            sessionStorage.removeItem('selectedErp');
            sessionStorage.removeItem('selectedDueStatus');
            return {
                state: "",
                plan: 0,
                status: 0,
                erp: 0,
                term: "",
                dueStatus: [],
            };
        }
        return {
            state: selectedState !== null && selectedState !== void 0 ? selectedState : "",
            plan: selectedPlan ? Number(selectedPlan) : 0,
            status: selectedStatus ? Number(selectedStatus) : 0,
            erp: selectedErp ? Number(selectedErp) : 0,
            term: savedSearchTerm !== null && savedSearchTerm !== void 0 ? savedSearchTerm : "",
            dueStatus: parseDueStatus(selectedDueStatus),
        };
    };
    var _a = useState([]), providers = _a[0], setProviders = _a[1];
    var _b = useState([]), states = _b[0], setStates = _b[1];
    var _c = useState([]), erps = _c[0], setErps = _c[1];
    var _d = useState([]), plans = _d[0], setPlans = _d[1];
    var _e = useState([]), status = _e[0], setStatus = _e[1];
    var _f = useState(null), paginateData = _f[0], setPaginateData = _f[1];
    var _g = useState(), paginateUrl = _g[0], setPaginateUrl = _g[1];
    var _h = useState(0), totalItems = _h[0], setTotalItems = _h[1];
    var initialFilters = useState(readInitialFilters)[0];
    var _j = useState(initialFilters.term), searchingTerm = _j[0], setSearchingTerm = _j[1];
    var perPage = useState(20)[0];
    var _k = useState(initialFilters.status), selectStatus = _k[0], setSelectStatus = _k[1];
    var _l = useState(initialFilters.state), selectState = _l[0], setSelectState = _l[1];
    var _m = useState(initialFilters.plan), selectPlan = _m[0], setSelectPlan = _m[1];
    var _o = useState(initialFilters.erp), selectErp = _o[0], setSelectErp = _o[1];
    var _p = useState(initialFilters.dueStatus), selectDueStatus = _p[0], setSelectDueStatus = _p[1];
    var _q = useState(""), sort = _q[0], setSort = _q[1];
    var _r = useState(1), currentPage = _r[0], setCurrentPage = _r[1];
    var _s = useState(true), isInitialized = _s[0], setIsInitialized = _s[1];
    var _t = useState(false), isLoading = _t[0], setIsLoading = _t[1];
    var abortControllerRef = useRef(null);
    var providersCacheRef = useRef(loadProvidersCache());
    var location = useLocation();
    void location;
    useEffect(function () {
        if (paginateUrl) {
            sessionStorage.setItem('paginateUrl', paginateUrl);
        }
    }, [paginateUrl]);
    useEffect(function () {
        function handlePopState() {
            var selectedState = sessionStorage.getItem('selectedState');
            var selectedPlan = sessionStorage.getItem('selectedPlan');
            var selectedStatus = sessionStorage.getItem('selectedStatus');
            var selectedDueStatus = sessionStorage.getItem('selectedDueStatus');
            var savedSearchTerm = sessionStorage.getItem('searchingTerm');
            if (selectedState)
                setSelectState(selectedState);
            if (selectedPlan)
                setSelectPlan(Number(selectedPlan));
            if (selectedStatus)
                setSelectStatus(Number(selectedStatus));
            if (selectedDueStatus)
                setSelectDueStatus(parseDueStatus(selectedDueStatus));
            if (savedSearchTerm)
                setSearchingTerm(savedSearchTerm);
        }
        window.addEventListener('popstate', handlePopState);
        return function () { return window.removeEventListener('popstate', handlePopState); };
    }, []);
    var getAllStatus = useCallback(function () {
        getCachedReference("cache:status", function () {
            return CustomerService.getAllStatus().then(function (r) { return r.data.status; });
        })
            .then(setStatus)
            .catch(handleServiceError);
    }, []);
    var getAllStates = useCallback(function () {
        getCachedReference("cache:states", function () {
            return CustomerService.getAllStates().then(function (r) { return r.data.states; });
        })
            .then(setStates)
            .catch(handleServiceError);
    }, []);
    var getAllErps = useCallback(function () {
        getCachedReference("cache:erps", function () {
            return CustomerService.getAllErps().then(function (r) { return r.data.erps; });
        })
            .then(setErps)
            .catch(handleServiceError);
    }, []);
    var getPlans = useCallback(function () {
        getCachedReference("cache:plans", function () {
            return CustomerService.getAllPlans().then(function (r) { return r.data.plans; });
        })
            .then(setPlans)
            .catch(handleServiceError);
    }, []);
    useEffect(function () {
        getPlans();
        getAllStatus();
        getAllStates();
        getAllErps();
    }, [getPlans, getAllStatus, getAllStates, getAllErps]);
    var handleFilterText = useCallback(function (event) {
        var valueCleaned = event.target.value.replace(/[./-]/g, "");
        setSearchingTerm(valueCleaned);
    }, []);
    var handleSortAction = useCallback(function (sortAction) {
        setSort(function (prev) { return (prev === sortAction ? "-" + sortAction : sortAction); });
    }, []);
    var buildParams = useCallback(function () {
        var params = {};
        if (sort && sort.trim() !== "")
            params.sort = sort.trim();
        if (selectStatus && selectStatus !== 0)
            params.customer_status_id = selectStatus;
        if (selectState && selectState.trim() !== "")
            params.state = selectState.trim();
        if (selectPlan && selectPlan !== 0)
            params.plan_id = selectPlan;
        if (selectErp && selectErp !== 0)
            params.erp_id = selectErp;
        if (selectDueStatus.length > 0)
            params.due_status = selectDueStatus;
        return params;
    }, [sort, selectStatus, selectState, selectPlan, selectErp, selectDueStatus]);
    var handleFilterAction = useCallback(function (value, filter) {
        if (filter === "customer_status_id") {
            setSelectStatus(Number(value));
            sessionStorage.setItem('selectedStatus', value);
        }
        else if (filter === "state") {
            var trimmed = value.trim();
            setSelectState(trimmed);
            sessionStorage.setItem('selectedState', trimmed);
        }
        else if (filter === "plan_id") {
            setSelectPlan(Number(value));
            sessionStorage.setItem('selectedPlan', value);
        }
        else if (filter === "erp_id") {
            setSelectErp(Number(value));
            sessionStorage.setItem('selectedErp', value);
        }
    }, []);
    var clearSingleFilter = useCallback(function (filterType) {
        if (filterType === "customer_status_id") {
            setSelectStatus(0);
            sessionStorage.removeItem('selectedStatus');
        }
        else if (filterType === "state") {
            setSelectState("");
            sessionStorage.removeItem('selectedState');
        }
        else if (filterType === "plan_id") {
            setSelectPlan(0);
            sessionStorage.removeItem('selectedPlan');
        }
        else if (filterType === "erp_id") {
            setSelectErp(0);
            sessionStorage.removeItem('selectedErp');
        }
    }, []);
    var handleCombinedChangeStatus = useCallback(function (event) {
        var value = event.target.value;
        if (value === "0" || value === "")
            clearSingleFilter("customer_status_id");
        else
            handleFilterAction(value, "customer_status_id");
        setCurrentPage(1);
    }, [clearSingleFilter, handleFilterAction]);
    var handleCombinedChangeState = useCallback(function (event) {
        var value = event.target.value;
        if (value === "")
            clearSingleFilter("state");
        else
            handleFilterAction(value, "state");
        setCurrentPage(1);
    }, [clearSingleFilter, handleFilterAction]);
    var handleCombinedChangePlan = useCallback(function (event) {
        var value = event.target.value;
        if (value === "0")
            clearSingleFilter("plan_id");
        else
            handleFilterAction(value, "plan_id");
        setCurrentPage(1);
    }, [clearSingleFilter, handleFilterAction]);
    var handleCombinedChangeErp = useCallback(function (event) {
        var value = event.target.value;
        if (value === "0" || value === "")
            clearSingleFilter("erp_id");
        else
            handleFilterAction(value, "erp_id");
        setCurrentPage(1);
    }, [clearSingleFilter, handleFilterAction]);
    var handleToggleDueStatus = useCallback(function (value) {
        setSelectDueStatus(function (prev) {
            var next = prev.includes(value)
                ? prev.filter(function (v) { return v !== value; })
                : __spreadArray(__spreadArray([], prev, true), [value], false);
            if (next.length > 0) {
                sessionStorage.setItem('selectedDueStatus', JSON.stringify(next));
            }
            else {
                sessionStorage.removeItem('selectedDueStatus');
            }
            return next;
        });
        setCurrentPage(1);
    }, []);
    var cleanFilter = useCallback(function () {
        var defaultKey = JSON.stringify({
            term: "",
            page: 1,
            customer_status_id: undefined,
            plan_id: undefined,
            state: undefined,
            sort: undefined,
            erp_id: undefined,
        });
        var defaultEntry = providersCacheRef.current.get(defaultKey);
        providersCacheRef.current.clear();
        if (defaultEntry) {
            providersCacheRef.current.set(defaultKey, defaultEntry);
        }
        persistProvidersCache(providersCacheRef.current);
        setSort("");
        setSelectState("");
        setSelectPlan(0);
        setSelectStatus(0);
        setSelectErp(0);
        setSelectDueStatus([]);
        setSearchingTerm("");
        setCurrentPage(1);
        sessionStorage.removeItem('searchingTerm');
        sessionStorage.removeItem('paginateUrl');
        sessionStorage.removeItem('selectedStatus');
        sessionStorage.removeItem('selectedState');
        sessionStorage.removeItem('selectedPlan');
        sessionStorage.removeItem('selectedErp');
        sessionStorage.removeItem('selectedDueStatus');
    }, []);
    var handleSearch = useCallback(function (providersSearch) {
        var raw = providersSearch.term.trim();
        var isDocumentLike = raw !== "" && !/[a-zA-Z]/.test(raw);
        var termToSearch = isDocumentLike ? raw.replace(/[./-]/g, "") : raw;
        setSearchingTerm(termToSearch);
        setCurrentPage(1);
        sessionStorage.setItem('searchingTerm', termToSearch);
        return Promise.resolve();
    }, []);
    var buildCacheKey = useCallback(function (page) {
        var _a = buildParams(), customer_status_id = _a.customer_status_id, plan_id = _a.plan_id, state = _a.state, sortParam = _a.sort, erp_id = _a.erp_id, due_status = _a.due_status;
        return JSON.stringify({
            term: searchingTerm,
            page: page,
            customer_status_id: customer_status_id,
            plan_id: plan_id,
            state: state,
            sort: sortParam,
            erp_id: erp_id,
            due_status: due_status,
        });
    }, [buildParams, searchingTerm]);
    var getProvidersRequest = useCallback(function (page, signal) {
        if (page === void 0) { page = 1; }
        var _a = buildParams(), customer_status_id = _a.customer_status_id, plan_id = _a.plan_id, state = _a.state, sortParam = _a.sort, erp_id = _a.erp_id, due_status = _a.due_status;
        return searchingTerm
            ? CustomerService.search(searchingTerm, perPage, signal, customer_status_id, plan_id, erp_id, state, page, sortParam, due_status)
            : CustomerService.allProviders(perPage, page, customer_status_id, plan_id, state, sortParam, signal, erp_id, due_status);
    }, [buildParams, searchingTerm, perPage]);
    var getProviders = useCallback(function (page, signal) {
        if (page === void 0) { page = 1; }
        var cacheKey = buildCacheKey(page);
        var cached = providersCacheRef.current.get(cacheKey);
        var isFresh = !!cached && Date.now() - cached.timestamp < PROVIDERS_CACHE_TTL;
        if (cached) {
            setProviders(cached.data);
            setPaginateData(cached.paginate);
            setTotalItems(cached.total);
            if (cached.firstPageUrl)
                setPaginateUrl(cached.firstPageUrl);
        }
        if (isFresh)
            return Promise.resolve();
        setIsLoading(true);
        return getProvidersRequest(page, signal)
            .then(function (res) {
            var customers = res.data.customers;
            providersCacheRef.current.set(cacheKey, {
                data: customers.data,
                paginate: customers,
                total: customers.total,
                timestamp: Date.now(),
            });
            persistProvidersCache(providersCacheRef.current);
            setProviders(customers.data);
            setPaginateData(customers);
            setTotalItems(customers.total);
        })
            .catch(function (err) {
            var signalAborted = (signal === null || signal === void 0 ? void 0 : signal.aborted) === true;
            var isAbort = signalAborted ||
                !err ||
                (err === null || err === void 0 ? void 0 : err.name) === 'CanceledError' ||
                (err === null || err === void 0 ? void 0 : err.name) === 'AbortError' ||
                (err === null || err === void 0 ? void 0 : err.code) === 'ERR_CANCELED' ||
                (err === null || err === void 0 ? void 0 : err.code) === 'ECONNABORTED';
            if (isAbort)
                return;
            handleServiceError(err);
        })
            .finally(function () {
            if (!(signal === null || signal === void 0 ? void 0 : signal.aborted)) {
                setIsLoading(false);
            }
        });
    }, [getProvidersRequest, searchingTerm, buildCacheKey]);
    var debouncedSelectStatus = useDebouncedValue(selectStatus, FILTER_DEBOUNCE_MS);
    var debouncedSelectState = useDebouncedValue(selectState, FILTER_DEBOUNCE_MS);
    var debouncedSelectPlan = useDebouncedValue(selectPlan, FILTER_DEBOUNCE_MS);
    var debouncedSelectErp = useDebouncedValue(selectErp, FILTER_DEBOUNCE_MS);
    var debouncedDueStatus = useDebouncedValue(selectDueStatus, FILTER_DEBOUNCE_MS);
    var debouncedSort = useDebouncedValue(sort, FILTER_DEBOUNCE_MS);
    useEffect(function () {
        var _a;
        if (!isInitialized)
            return;
        (_a = abortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
        var controller = new AbortController();
        abortControllerRef.current = controller;
        getProviders(currentPage, controller.signal);
        return function () { return controller.abort(); };
    }, [
        getProviders,
        currentPage,
        isInitialized,
        debouncedSelectStatus,
        debouncedSelectState,
        debouncedSelectPlan,
        debouncedSelectErp,
        debouncedDueStatus,
        debouncedSort,
    ]);
    useEffect(function () {
        if (!isInitialized || !paginateData)
            return;
        var totalPages = Math.ceil(totalItems / perPage);
        if (currentPage >= totalPages)
            return;
        var timer = setTimeout(function () {
            var nextPage = currentPage + 1;
            var nextKey = buildCacheKey(nextPage);
            if (providersCacheRef.current.has(nextKey))
                return;
            var _a = buildParams(), customer_status_id = _a.customer_status_id, plan_id = _a.plan_id, state = _a.state, sortParam = _a.sort, erp_id = _a.erp_id, due_status = _a.due_status;
            var prefetchRequest = searchingTerm
                ? CustomerService.search(searchingTerm, perPage, undefined, customer_status_id, plan_id, erp_id, state, nextPage, sortParam, due_status)
                : CustomerService.allProviders(perPage, nextPage, customer_status_id, plan_id, state, sortParam, undefined, erp_id, due_status);
            prefetchRequest
                .then(function (res) {
                var customers = res.data.customers;
                providersCacheRef.current.set(nextKey, {
                    data: customers.data,
                    paginate: customers,
                    total: customers.total,
                    timestamp: Date.now(),
                });
                persistProvidersCache(providersCacheRef.current);
            })
                .catch(function () {
            });
        }, PREFETCH_DELAY_MS);
        return function () { return clearTimeout(timer); };
    }, [
        isInitialized,
        paginateData,
        searchingTerm,
        currentPage,
        totalItems,
        perPage,
        buildParams,
        buildCacheKey,
    ]);
    var handlePageChange = useCallback(function (_event, value) {
        setCurrentPage(value);
    }, []);
    return {
        providers: providers,
        setProviders: setProviders,
        perPage: perPage,
        states: states,
        selectState: selectState,
        erps: erps,
        selectErp: selectErp,
        plans: plans,
        status: status,
        paginateData: paginateData,
        getPlans: getPlans,
        getAllStatus: getAllStatus,
        handleSearch: handleSearch,
        selectStatus: selectStatus,
        handleCombinedChangeStatus: handleCombinedChangeStatus,
        handleSortAction: handleSortAction,
        selectPlan: selectPlan,
        handleCombinedChangeState: handleCombinedChangeState,
        handleCombinedChangePlan: handleCombinedChangePlan,
        handleCombinedChangeErp: handleCombinedChangeErp,
        selectDueStatus: selectDueStatus,
        handleToggleDueStatus: handleToggleDueStatus,
        totalItems: totalItems,
        currentPage: currentPage,
        handlePageChange: handlePageChange,
        cleanFilter: cleanFilter,
        searchingTerm: searchingTerm,
        handleFilterText: handleFilterText,
        clearSingleFilter: clearSingleFilter,
        isLoading: isLoading,
    };
};
export default useCustomerData;
